import React from 'react';
var Loader = function Loader() {
  return /*#__PURE__*/React.createElement("div", {
    className: "loader__container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "loader__content"
  }, /*#__PURE__*/React.createElement("svg", {
    className: "loader__circular",
    viewBox: "25 25 50 50"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "loader__circular__background",
    cx: "50",
    cy: "50",
    r: "20",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "loader__circular__foreground",
    cx: "50",
    cy: "50",
    r: "20",
    fill: "none"
  }))));
};
export default Loader;